import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Spinner } from '@elbklar/ui';

import { FinanceLayout } from '@/components/layout/FinanceLayout';
import { useAuth } from '@/features/auth/AuthContext';
import { LoginPage } from '@/features/auth/LoginPage';
import { AuthCallbackPage } from '@/features/auth/AuthCallbackPage';
import { OverviewPage } from '@/features/overview/OverviewPage';
import { PlanungPage } from '@/features/planung/PlanungPage';
import { RadarPage } from '@/features/radar/RadarPage';
import { ProgrammSeite } from '@/features/radar/ProgrammSeite';
import { anmeldeAdresse } from '@/features/auth/sitzung';
import { BuchungenPage } from '@/features/buchungen/BuchungenPage';
import { ImportPage } from '@/features/import/ImportPage';
import { FixkostenPage } from '@/features/fixkosten/FixkostenPage';
import { KreditPage } from '@/features/kredit/KreditPage';
import { KategorienPage } from '@/features/kategorien/KategorienPage';
import { EinstellungenPage } from '@/features/einstellungen/EinstellungenPage';

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <Spinner size={32} label="Anmeldung wird geprüft" />
      </div>
    );
  }

  // Mit der aufgerufenen Adresse als Ziel: Ein Link aus einer Radar-Mail
  // führt nach der Anmeldung auf den Eintrag, nicht auf die Übersicht.
  if (!isAuthenticated) {
    return <Navigate to={anmeldeAdresse(location.pathname + location.search + location.hash)} replace />;
  }

  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Landepunkt des OAuth-Rueckwegs — muss ausserhalb von ProtectedRoute
          liegen, sonst wird der gerade Angemeldete wieder zum Login geschickt. */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route
        element={
          <ProtectedRoute>
            <FinanceLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<OverviewPage />} />
        <Route path="/planung" element={<PlanungPage />} />
        <Route path="/radar" element={<RadarPage />} />
        <Route path="/radar/:id" element={<ProgrammSeite />} />
        <Route path="/buchungen" element={<BuchungenPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/fixkosten" element={<FixkostenPage />} />
        <Route path="/kredit" element={<KreditPage />} />
        <Route path="/kategorien" element={<KategorienPage />} />
        <Route path="/einstellungen" element={<EinstellungenPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
